import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class BackToOnApproval extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.BACK_TO_ON_APPROVAL]);
  }
}

export default BackToOnApproval;
